// @ts-nocheck

const getExaminationReviewToasts = () => {
  return window?._activeExaminationReviewToasts || {};
};

const setExaminationReviewToasts = (activeToasts) => {
  window._activeExaminationReviewToasts = activeToasts;
};

export const clearActiveExaminationReviewToast = (toastId, snackbarKey) => {
  if (!toastId) {
    return;
  }

  const activeToasts = getExaminationReviewToasts();

  if (snackbarKey && activeToasts?.[toastId] !== snackbarKey) {
    return;
  }

  delete activeToasts[toastId];
  setExaminationReviewToasts(activeToasts);
};

export const showExaminationReviewToast = (data = {}, toastOptions = {}) => {
  if (!window?.enqueueSnackbar) {
    return {
      shown: false,
      snackbarKey: null,
    };
  }

  const toastId = String(data?.toastId || `examination-${Date.now()}`);
  const activeToasts = getExaminationReviewToasts();

  if (activeToasts?.[toastId]) {
    return {
      shown: false,
      snackbarKey: activeToasts?.[toastId] || null,
    };
  }

  const snackbarKey = `examination-review-${toastId}`;

  setExaminationReviewToasts({
    ...activeToasts,
    [toastId]: snackbarKey,
  });

  window.enqueueSnackbar(
    JSON.stringify({
      ...data,
      toastId,
    }),
    {
      variant: 'examinationReview',
      key: snackbarKey,
      persist: true,
      anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
      ...toastOptions,
    }
  );

  return {
    shown: true,
    snackbarKey,
  };
};
